import React from 'react';
import { Table, Row, Col, Button, Dropdown, Pagination, Image } from 'antd';
import { SettingOutlined, DownCircleOutlined, CloseCircleOutlined, EditOutlined, HistoryOutlined, AppstoreAddOutlined } from '@ant-design/icons';

import { getParamTable, _tableLogActivity } from '../../../../lib/Helper';
import { Link } from 'react-router-dom';

class Desktop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    };
  }

  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  sorter: false,
                  width: '2%',
                }, {
                  title: 'Kategori',
                  dataIndex: 'kategori_nama',
                  sorter: false,
                }, {
                  title: 'Barang',
                  dataIndex: 'nama',
                  sorter: false,
                }, {
                  title: 'Satuan',
                  dataIndex: 'satuan',
                  sorter: false,
                }, {
                  title: 'Stock',
                  dataIndex: 'qty_available',
                  sorter: false,
                }, {
                  title: 'Keterangan',
                  dataIndex: 'keterangan',
                  sorter: false,
                }, {
                  title: 'Foto',
                  dataIndex: 'foto',
                  sorter: false,
                  render: (a, row) => !row.foto ? "-" : <Image.PreviewGroup>
                    <Image style={{
                      width: 70,
                    }} src={row.main_path + row.foto} />
                  </Image.PreviewGroup>
                }, {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => <Dropdown trigger={['click']} menu={{
  items: [...(action.update === true ? [{
    key: 0,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.delete === true ? [{
    key: 1,
    icon: <CloseCircleOutlined />,
    label: "Delete",
    onClick: this.props.modalDelete.bind(this, true, row)
  }] : []), ...(action.create === true ? [{
    key: 2,
    icon: <AppstoreAddOutlined />,
    label: "Tambah Transaksi",
    onClick: this.props.modalFormTransaksi.bind(this, true, row)
  }] : []), ...(action.history === true ? [{
    key: 3,
    label: <Link to={`asset-lancar/history/${row.nama}/${row.id}`}><HistoryOutlined /> History Transaksi</Link>
  }] : [])]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>,
                }, {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default Desktop;
